import * as yup from "yup";
import { convertDateToString } from "../utility/ConvertUtily";

const now = new Date();
export const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

export type OptionContract = {
  id: string;
  optionId: string;
  optionName: string;
  status: boolean;
  applicableStartDate: Date | null;
  applicableFinishDate: Date | null;
  sort?: number;
};

// オプション契約の初期値
export const initOptionContract = (): OptionContract[] => {
  return [
    {
      id: "",
      optionId: "userIdCard",
      optionName: "利用者IDカード",
      status: false,
      applicableStartDate: null,
      applicableFinishDate: null,
    }
  ];
};

export const optionContractTimestampToDate = (data: any | undefined): OptionContract => {
  if(data.applicableStartDate !== null){
    const startDate = new Date(data.applicableStartDate.seconds * 1000);
    data.applicableStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  }
  if(data.applicableFinishDate !== null){
    const finishDate = new Date(data.applicableFinishDate.seconds * 1000);
    data.applicableFinishDate = new Date(finishDate.getFullYear(), finishDate.getMonth(), finishDate.getDate());
  }
  return data;
};

export const optionContractSchema = yup.object({
  applicableStartDate: yup.date().nullable().transform((value, originalValue) => {
    if (originalValue === "") return null;
    return value;
  }),
  applicableFinishDate: yup.date().nullable().transform((value, originalValue) => {
    if (originalValue === "") return null;
    return value;
  }).test((value, testContext) => {
    if (testContext.parent.status === true) {
      const finishDate = new Date(testContext.parent.applicableFinishDate === null ? "" : testContext.parent.applicableFinishDate);
      const startDate = new Date(testContext.parent.applicableStartDate === null ? "" : testContext.parent.applicableStartDate);
      if (nowDate > finishDate) {
        return testContext.createError({
          message: `${convertDateToString(nowDate)}以降を入力してください。`
        })
      }
      if((!Number.isNaN(startDate.getTime())) && (!Number.isNaN(finishDate.getTime())) && finishDate <= startDate){
        return testContext.createError({
          message: `終了日は開始日以降を入力してください。`
        })
      }
    }
    return true;
  }),
})
